import React from 'react';
import * as S from './link.styled';
export var Link = function Link(_ref) {
  var className = _ref.className,
    children = _ref.children,
    to = _ref.to,
    target = _ref.target,
    linker = _ref.linker,
    isExternal = _ref.isExternal,
    isActive = _ref.isActive,
    setTargetBlankOnExternalLink = _ref.setTargetBlankOnExternalLink,
    rel = _ref.rel,
    dataTestid = _ref.dataTestid;
  var linkProps = {
    className: className,
    href: to,
    target: target,
    rel: rel,
    'data-testid': dataTestid
  };
  if (setTargetBlankOnExternalLink && isExternal) {
    linkProps.target = '_blank';
  } // Adding a rel='noopener noreferer' protects from a vulnerability called reverse tabnabbing.
  // Read about it here: https://mathiasbynens.github.io/rel-noopener/
  // And here: https://techblog.topdesk.com/security/developers-need-know-reverse-tabnabbing/

  if (linkProps.target === '_blank' && !linkProps.rel) {
    linkProps.rel = 'noopener noreferer';
  }
  if (isActive) {
    linkProps.className = 'active';
  }
  if (linker) {
    return linker(children, linkProps);
  }
  return /*#__PURE__*/React.createElement(S.LinkStyle, linkProps, children);
};
Link.defaultProps = {
  to: '#',
  target: null,
  linker: null,
  isExternal: false,
  isActive: false,
  setTargetBlankOnExternalLink: true,
  rel: null
};